export const sanitizeVendingSalesIntegerInput = (value: string) => value.replace(/[^\d]/g, '');

export const sanitizeVendingSalesDecimalInput = (value: string) => {
  return value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
};
